import { apiPath } from '../../config';
import { axiosInstance } from './AxiosInstance';

export const getAllCanteens = async () => {
  return axiosInstance.get(apiPath.canteens);
};
